import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@lciapps/auth';
import { User, UserService } from '@lciapps/lci-core';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { environment } from '../environments/environment';
import { FeatureService } from './feature.service';
import { UserProfileImageSizes } from './features/activities/models/image-resize.enum';

@Component({
  selector: 'app-auth-nav',
  template: `
    <div class="nav">
      <div class="nav-top">
        <img
          style="margi-left: 20px;max-height: 30px;float: left;margin-left: 30px;margin-top: 1px;"
          alt="MyLion Logo"
          src="/assets/images/transparent_logo.gif"
        />
        <!--     <a href translate="btnContactUs">Contact Us</a> -->
        <div class="lci-translation">
          <app-lci-tranlsation-header></app-lci-tranlsation-header>
        </div>
        <a
          href
          translate="btnSupport"
          [href]="zenDeskUrl"
          target="_blank"
          (click)="reloadZendeskUrl($event)"
          >Support</a
        >
        <a *ngIf="showMessage" [attr.href]="messageUrl" translate="lblMessages"
          >Messages</a
        >
        <span class="user-menu">
          <div class="user-image"><div [ngStyle]="getProfileImageStyle()"></div></div>
          <a href (click)="toggleMenu($event)">
            {{ getUserName() }} <mat-icon>expand_more</mat-icon>
          </a>
          <div class="triangle" *ngIf="menuToggled">
            <div class="inner-triangle"></div>
          </div>
          <div class="user-menu" *ngIf="menuToggled">
            <ul>
              <li>
                <a
                  href="${environment.userProfileAppUrl}"
                  translate="btnMyProfile"
                  >My Profile</a
                >
              </li>
              <li>
                <a href (click)="navigateLogout($event)" translate="menuLogout"
                  >Logout</a
                >
              </li>
            </ul>
          </div>
        </span>
      </div>
    </div>
    <!--    <p>
      <a routerLink="/root/protected" href>Secure Area</a><span *ngIf="loggedIn"> | </span>
      <a href (click)="signout()" *ngIf="loggedIn">Sign Out</a>
    </p> -->
  `,
  styles: [
    `
    .triangle {
        position: absolute;
        right: 35px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 11.5px 10px 11.5px;
        border-color: transparent transparent #e8e6e6; transparent;
    }

    .inner-triangle {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 10.5px 8px 10.5px;
        border-color: transparent transparent #ffffff transparent;
        position: absolute;
        left: -11px;
        top: 1px;
    }

    .nav {
        width: 100%;
        height: 32px;
        background-color: #153054;
    }

    .nav-top {
        width: 100%;
        text-align: right;
    }

    .nav-top a {
        font-family: 'Helvetica Neue';
        line-height: 32px;
        color: #fff;
        margin-right: 3%;
        font-size: 11px;
        vertical-align:top;
        display: inline-flex;
        align-items: center;
    }

    .nav-top a:hover {
        text-decoration: none;
    }

    .user-image {
        width: 25px;
        height: 25px;
        border-radius: 25px;
        background-position: center center;
        background-repeat: no-repeat;
        background-image:url("../assets/images/liondefaultuser.png");
        background-size: cover;
        display:inline-block;
        margin-right: 5px;
        margin-top: 3px;
    }
    .user-image   div{
      width: 25px;
      height: 25px;
      border-radius: 25px;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;

    }

    span.user-menu {
        position:relative;
        padding-right: 10px;
    }

    div.user-menu {
        top:29px;
        width: 105px;
        border-radius: 5px;
        background-color: white;
        box-shadow: 2px 2px 2px 2px #e8e6e6;
        right: 35px;
        position:absolute;
        /*0px 2px 9px 3px #e8e6e6*/
        z-index: 1;

    }

    div.user-menu ul {
        list-style: none;
        padding-left: 0;
        text-align: left;
        margin-bottom: 0;
    }

    div.user-menu ul li a {
        color: #000;
        font-size: 11px;
        height: 34px;
        line-height: 34px;
        display:block;
        width: 100%;
        padding-left: 15px;
    }

    div.user-menu ul li a:hover, div.user-menu ul li a.active {
        background-color: #d8e8fa;
    }

    app-lci-tranlsation-header{
      font-family: helvetica, sans-serif;
      line-height: 32px;
      color: #fff;
      vertical-align:top;
      display: flex;
      align-items: center;
  }
  .lci-translation{
    position: absolute;
    right: 40%;
}

  `,
  ],
})
export class AuthNavComponent implements OnInit {
  public zenDeskUrl = '';
  loggedIn = false;
  user: User;
  menuToggled = false;
  public messageUrl = null;
  MYLION = 'MyLion';
  showMessage = false;
  CANMESSAGE = 'CanMessage';
  constructor(
    private authService: AuthService,
    private featureService: FeatureService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private angulartics: Angulartics2GoogleAnalytics
  ) { }

  ngOnInit() {
    this.featureService.zenDeskUrl.subscribe((url) => {
      this.zenDeskUrl = url;
    });
    this.userService.userLoaded.subscribe((user) => {
      this.user = user;
      if (user.claims.find((c) => c.claimType === this.MYLION)) {
        if (user.claims.find((c) => c.claimType === this.CANMESSAGE)) {
          this.messageUrl = environment.messageAppUrl;
          this.showMessage = true;
        }
      } else {
        this.messageUrl = null;
        this.showMessage = false;
      }
    });
  }

  reloadZendeskUrl($event) {
    this.angulartics.eventTrack('Contact Support', {
      label: 'Contact Support',
      MembershipType: this.featureService.GaMemberShipType,
    });

    this.featureService.getZendeskUrl().subscribe();
  }

  toggleMenu($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.menuToggled = !this.menuToggled;
  }

  getProfileImageStyle(): any {
    if (this.user) {
      const background = (this.user.userProfile["processedPhotoUrls"] && this.user.userProfile["processedPhotoUrls"][UserProfileImageSizes.image_25x25]) ? this.user.userProfile["processedPhotoUrls"][UserProfileImageSizes.image_25x25] : this.user.userProfile.photoUrl;
      return { backgroundImage: 'url(' + background + ')' };
    }
    return {};
  }

  getUserName(): string {
    if (this.user) {
      return (
        this.user.userProfile.firstName + ' ' + this.user.userProfile.lastName
      );
    }
    return '';
  }

  signout() {
    this.authService.startSignoutMainWindow();
  }

  navigateLogout($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.menuToggled = false;
    this.authService.manager.signoutRedirect();
  }

  contactHelp($event) {
    if ($event) {
      $event.stopPropagation();
      $event.preventDefault();
    }
    this.featureService.getZendeskUrl().subscribe((url) => {
      window.open(url, '_blank');
    });
  }
}
